<template>
  <div class="columns">
    <div class="column is-12">
      <div class="box">
        <h1>Concluído</h1>
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'sc-finished',
  };
</script>
  
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-finished/ScFinished.vue